import React from "react";
import DataTableBase from "./dataTableBase";
import { useOrganisationActions } from "../../hooks/useOrganisations";
import { CircularProgress, Alert } from "@mui/material";

export default function OrganisationActions(props) {
  const { organisation_id } = props;

  const {
    data: actions = [],
    isLoading,
    error,
  } = useOrganisationActions(organisation_id, { enabled: !!organisation_id });

  const actionColumns = [
    {
      name: "id",
      label: "ID",
      options: {
        sort: true,
        display: false,
      },
    },
    {
      name: "name",
      label: "Name",
      options: {
        sort: true,
        filter: true,
      },
    },
    {
      name: "action_type",
      label: "Action Type",
      options: {
        sort: true,
        filter: true,
      },
    },
    {
      name: "active",
      label: "Active",
      options: {
        sort: true,
        filter: true,
      },
    },
    {
      name: "alert_type",
      label: "Alert Type",
      options: {
        sort: true,
        filter: true,
      },
    },
    {
      name: "message",
      label: "Message",
      options: {
        sort: true,
        filter: true,
      },
    },
    {
      name: "out_of_hours",
      label: "Out of Hours",
      options: {
        sort: true,
        filter: true,
      },
    },
    {
      name: "threshold",
      label: "Threshold",
      options: {
        sort: true,
        filter: true,
      },
    },
  ];

  if (isLoading) {
    return <CircularProgress />;
  }

  if (error) {
    return <Alert severity="error">Failed to load organisation actions</Alert>;
  }

  return (
    <DataTableBase
      title={"Organisation Actions"}
      data={actions}
      columns={actionColumns}
      orderby="time_created"
      orderdirection="desc"
    />
  );
}
